import * as React from 'react';
export var headingSectionIllustrationPositionContext = React.createContext('after');
